import { api } from "@vuumly-common/common";
import { BaseCard } from "components/Card/index";
import { TextH5 } from "components/Typography/Text";
import { useDateRange, useQuery, useTranslate, useUserContext } from "hooks";
import { useSearchParams } from "react-router-dom";

type Item = {
  dimension: string;
  ride_count: number;
};

export const RidesTotalCard = () => {
  const translate = useTranslate();
  const [searchParams] = useSearchParams();
  const { locale } = useUserContext();
  const { selectedDaysCount } = useDateRange();

  const params = new URLSearchParams(searchParams);

  params.set("data_structure", "flat");

  const { data, isLoading } = useQuery<Item[]>({
    apiEndpoint: api.Endpoint.RidesTotalCompanies,
    params,
  });

  const total = data?.reduce((acc, item) => acc + item.ride_count, 0) || 0;

  const formattedTotal = Intl.NumberFormat(locale, {
    notation: "compact",
  }).format(total || 0);

  const avgRidesPerDay = total / (selectedDaysCount || 0);

  const avgPerDayFormatted = Intl.NumberFormat(locale, {
    notation: "compact",
  }).format(avgRidesPerDay);

  return (
    <div className="flex space-x-4">
      <BaseCard
        isLoading={isLoading}
        header={<TextH5>{translate("Total ride count")}</TextH5>}
      >
        <div className="text-xl">{formattedTotal}</div>
      </BaseCard>
      <BaseCard
        isLoading={isLoading}
        header={<TextH5>{translate("Average rides per day")}</TextH5>}
      >
        <div className="text-xl">{avgPerDayFormatted}</div>
      </BaseCard>
    </div>
  );
};
